import { render, staticRenderFns } from "./BadgeNew.vue?vue&type=template&id=abe22e5c&scoped=true"
import script from "./BadgeNew.vue?vue&type=script&lang=js"
export * from "./BadgeNew.vue?vue&type=script&lang=js"
import style0 from "./BadgeNew.vue?vue&type=style&index=0&id=abe22e5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe22e5c",
  null
  
)

export default component.exports